import { ResolveFn } from '@angular/router';
import { Observable, tap, of } from 'rxjs';
import { inject } from '@angular/core';
import { Organization, OrganizationService } from 'riterz-core';

export const organizationResolver: ResolveFn<Observable<Organization|null>> = (
  route, 
  state,
  organizationService: OrganizationService = inject(OrganizationService),
) => {
  const organizationId = route.paramMap.get('organizationId');
  const params = {
    include: 'country,industry.category',
  }

  if (!organizationId) {
    return of(null);
  }

  return organizationService
    .getPublicOrganization(organizationId, params)
    .pipe(
      tap({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: () => {}
      })
    );
    
};
